import React, { useState } from 'react';
import { ArrowRight, Star, Lock, Clock, ShieldCheck, CreditCard } from 'lucide-react';
type PlanId = 'profesional' | 'elite';
export function PricingSelector() {
  const [selected, setSelected] = useState<PlanId>('elite');
  const isElite = selected === 'elite';
  return <div className="max-w-xl mx-auto" data-id="element-283">
      {/* White card containing the whole selector */}
      <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-8" data-id="element-284">
        <div className="text-center mb-8" data-id="element-285">
          <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-286">
            Elegí tu Pack:
          </h3>
          <p className="text-gray-500 text-lg max-w-xs mx-auto" data-id="element-287">
            Ambas opciones incluyen los 6 Bonus estratégicos
          </p>
        </div>

        <div className="space-y-5" data-id="element-288">
          {/* Pack Profesional */}
          <button type="button" onClick={() => setSelected('profesional')} aria-pressed={selected === 'profesional'} className={`w-full text-left rounded-2xl border-2 p-5 flex items-center gap-4 transition-all ${selected === 'profesional' ? 'border-blue-600 bg-blue-50/60' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-289">
            <Radio active={selected === 'profesional'} color="#2563a8" data-id="element-290" />
            <div className="flex-1 min-w-0" data-id="element-291">
              <h4 className="text-lg md:text-xl font-extrabold text-gray-900 leading-tight flex items-center gap-2" data-id="element-292">
                📘 PACK PROFESIONAL
              </h4>
              <p className="text-gray-500 text-sm mt-1" data-id="element-293">12 Tomos + 6 Bonus</p>
            </div>
            <div className="text-right shrink-0" data-id="element-294">
              <p className="text-gray-400 line-through text-sm" data-id="element-295">$29.990</p>
              <p className="text-2xl md:text-3xl font-extrabold text-gray-900" data-id="element-296">
                $18.990
              </p>
            </div>
          </button>

          {/* Megapack Élite */}
          <button type="button" onClick={() => setSelected('elite')} aria-pressed={isElite} className={`w-full text-left rounded-2xl border-2 p-5 flex items-start gap-4 transition-all ${isElite ? 'border-[#c07a5b] bg-[#fbf1ea]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-297">
            <div className="pt-1" data-id="element-298">
              <Radio active={isElite} color="#c07a5b" data-id="element-299" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-300">
              <h4 className="text-lg md:text-xl font-extrabold text-gray-900 leading-tight flex items-center gap-2 mb-2" data-id="element-301">
                🏆 MEGAPACK ÉLITE
              </h4>
              <div className="flex flex-wrap gap-2 mb-2" data-id="element-302">
                <span className="inline-flex items-center gap-1 bg-yellow-400 text-yellow-900 font-bold text-xs px-3 py-1 rounded-full" data-id="element-303">
                  <Star size={12} className="fill-current" data-id="element-304" /> MÁS ELEGIDO
                </span>
                <span className="inline-flex items-center bg-[#f3ddd0] text-[#b5613f] font-bold text-xs px-3 py-1 rounded-full" data-id="element-305">
                  AHORRÁS $22.000
                </span>
              </div>
              <p className="text-gray-500 text-sm" data-id="element-306">
                12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
              </p>
            </div>
            <div className="text-right shrink-0" data-id="element-307">
              <p className="text-gray-400 line-through text-sm" data-id="element-308">$49.990</p>
              <p className="text-2xl md:text-3xl font-extrabold text-[#c07a5b]" data-id="element-309">
                $27.990
              </p>
            </div>
          </button>
        </div>

        {/* Dynamic CTA */}
        <button className="mt-7 w-full bg-[#c07a5b] hover:bg-[#af6c4e] text-white font-extrabold text-lg md:text-xl py-5 px-6 rounded-2xl transition-colors flex flex-col items-center justify-center gap-1 shadow-sm" data-id="element-310">
          <span data-id="element-311">
            {isElite ? 'SÍ, QUIERO EL MEGAPACK ÉLITE' : 'QUIERO EL PACK PROFESIONAL'}
          </span>
          <ArrowRight size={22} data-id="element-312" />
        </button>

        <p className="text-center text-sm text-gray-400 italic mt-5 px-4" data-id="element-313">
          La opción más elegida por profesores de Biología argentinos
        </p>
      </div>

      {/* Trust badges below the card */}
      <div className="grid grid-cols-2 gap-x-6 gap-y-4 text-sm text-gray-500 mt-8 max-w-md mx-auto" data-id="element-314">
        <span className="flex items-center gap-2" data-id="element-315">
          <Lock size={18} className="text-gray-400" data-id="element-316" /> Pago seguro
        </span>
        <span className="flex items-center gap-2" data-id="element-317">
          <Clock size={18} className="text-yellow-500" data-id="element-318" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-2" data-id="element-319">
          <ShieldCheck size={18} className="text-green-500" data-id="element-320" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-2" data-id="element-321">
          <CreditCard size={18} className="text-gray-400" data-id="element-322" /> Tarjeta ·
          Transferencia
        </span>
      </div>
    </div>;
}
function Radio({
  active,
  color
}: {
  active: boolean;
  color: string;
}) {
  return <span className="shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors" style={{
    borderColor: active ? color : '#cbd5e1'
  }} data-id="element-323">
      {active && <span className="w-3 h-3 rounded-full" style={{
      backgroundColor: color
    }} data-id="element-324" />}
    </span>;
}